import React from 'react'
// components
import SecurityProfilesAPI from 'containers/Security/components/SecurityProfiles/layers/API'
import SecurityProfiles from 'components/PageComponents/Settings/Security/components/SecurityProfiles'

const SecurityProfilesContainer: React.FC = () => {
  return (
    <SecurityProfilesAPI>
      <SecurityProfiles />
    </SecurityProfilesAPI>
  )
}

export default SecurityProfilesContainer
